module.exports = __webpack_public_path__ + "static/img/brmm3.9d511b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/brmm3.png
// module id = lA+M
// module chunks = 0